import React from "react"
import { Checkbox, Feed, Icon, Message, Popup } from "semantic-ui-react"
import BifrostWaringIcon from "../../../BifrostElementComponent/BifrostWarningIcon/BifrostWaringIcon.jsx"
import Loader from "../../../BifrostPageComponent/Loader/Loader"
import { useDirectTunnelToggleButton } from "../hooks/useDirectTunnelToggleButton"

const DirectTunnelToggleButton = ({ dimmerDirectTunnel, directTunnelStatus, refreshServiceStatus, orgId, handleDimmerDirectTunnel }, ref) => {
	const REQUIRED_FIRMWARE = "v4.11.0"
	const { isDisabledToggleButton, toggleDirectTunnelState, handleToggleButton } = useDirectTunnelToggleButton(
		ref,
		dimmerDirectTunnel,
		directTunnelStatus,
		refreshServiceStatus,
		orgId,
		handleDimmerDirectTunnel
	)

	return (
		<Feed.Content>
			<Feed.Summary>Direct Tunnel {directTunnelStatus.error && <BifrostWaringIcon content={directTunnelStatus.error} />}</Feed.Summary>
			<Feed.Extra text className={"device-change-disabled"} style={{ justifyContent: "space-between" }}>
				<div style={{ display: "flex", alignItems: "center" }}>
					<Popup
						disabled={!isDisabledToggleButton}
						content={`Firmware ${REQUIRED_FIRMWARE} or higher required`}
						wide="very"
						on="click"
						trigger={
							<Checkbox
								disabled={isDisabledToggleButton || directTunnelStatus.error}
								checked={directTunnelStatus.data?.enableDirectTunnel}
								toggle
								onChange={(e, data) => handleToggleButton(data.checked)}
							/>
						}
					/>
					<div style={{ marginRight: "10px" }}>{directTunnelStatus.data?.enableDirectTunnel ? "On" : "Off"}</div>
					{(directTunnelStatus.isFetching || toggleDirectTunnelState.isFetching) && <Loader backgroundColor="white" inverted size="small" />}
					{toggleDirectTunnelState.isSuccess && <Icon name="check circle outline" size="large" style={{ color: "#39C4AA" }} />}
					{toggleDirectTunnelState.error && <Icon name="close" size="large" style={{ color: "darkred" }} />}
				</div>
				{toggleDirectTunnelState.error && (
					<Message negative size="mini" className="small-message">
						<Message.Content>{toggleDirectTunnelState.error}</Message.Content>
					</Message>
				)}
			</Feed.Extra>
		</Feed.Content>
	)
}

export default React.forwardRef(DirectTunnelToggleButton)
